'use strict';

import React from 'react';
import PropTypes from 'prop-types';

class Contacts extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      isHover: false
    };

    this.handlerClick = this.handlerClick.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handlerClick (e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.onClick();
  }

  handleMouseEnter () {
    this.setState({
      isHover: true
    });
  }

  handleMouseLeave () {
    this.setState({
      isHover: false
    });
  }

  getValue () {
    const {value} = this.props;

    return value ? value.slice(0, -3) + '...' : '';
  }

  render () {
    const value = this.getValue();
    const {isHover} = this.state;

    return (
      <button type='button'
        onClick={this.handlerClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        className='btn-base btn-hollow btn-contacts'>
        <span className='icon-phone' />
        {
          isHover
          ? <span>Показать телефон</span>
          : <span>{ value }</span>
        }
      </button>
    );
  }
}

Contacts.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func
};

export default Contacts;



// WEBPACK FOOTER //
// ./src/ui/Buttons/Contacts.jsx